export const ALLOWED_CV_EXTENSIONS = ["pdf", "doc", "docx", "odt"] as const

export const ALLOWED_CV_MIME_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.oasis.opendocument.text",
] as const

export const MAX_CV_SIZE_BYTES = 20 * 1024 * 1024
export const CV_UPLOAD_PREFIX = "funnel-dev/cv"

const CV_FILENAME_SANITIZER = /[^a-zA-Z0-9._-]/g
const PATHNAME_PATTERN =
  /^funnel-dev\/cv\/\d{4}\/\d{2}\/[a-zA-Z0-9._-]+\.(pdf|doc|docx|odt)$/i

export const getCvExtension = (filename: string) => {
  const extension = filename.split(".").pop()?.toLowerCase()
  return extension || ""
}

export const isAllowedCvExtension = (filename: string) => {
  const extension = getCvExtension(filename)
  return ALLOWED_CV_EXTENSIONS.includes(
    extension as (typeof ALLOWED_CV_EXTENSIONS)[number]
  )
}

export const isAllowedCvMimeType = (mimeType: string) => {
  return ALLOWED_CV_MIME_TYPES.includes(
    mimeType as (typeof ALLOWED_CV_MIME_TYPES)[number]
  )
}

export const sanitizeFilename = (filename: string) => {
  const sanitized = filename.replace(CV_FILENAME_SANITIZER, "-")
  return sanitized.replace(/-+/g, "-")
}

export const buildCvBlobPathname = (
  filename: string,
  date = new Date()
): string => {
  const year = date.getUTCFullYear().toString()
  const month = String(date.getUTCMonth() + 1).padStart(2, "0")
  const extension = getCvExtension(filename)
  const basename = sanitizeFilename(filename.replace(/\.[^/.]+$/, ""))
  const nonce = crypto.randomUUID().slice(0, 8)
  return `${CV_UPLOAD_PREFIX}/${year}/${month}/${Date.now()}-${basename}-${nonce}.${extension}`
}

export const isValidCvBlobPathname = (pathname: string) => {
  return PATHNAME_PATTERN.test(pathname)
}
